import React from 'react';

import Spinner from '../../../../components/loaders/Spinner';

const PromoClaimLoadingContent = () => (
    <div className="modal-child-content">
        <Spinner show />
    </div>
);

export default PromoClaimLoadingContent;
